import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { CaseQuery } from 'dashboard/models/case-query';
import { FormEditCaseQueryData } from 'dashboard/views/DashboardCaseTemplatesShowView/CaseQueryTable/FormEditCaseQuery';
import { ApiModel, ApiPayload, ApiSingletonPayload } from 'lib/interfaces/api';

export const createCaseQuery = ({
  caseTemplateId,
  queryType,
  dataSourceId,
  name,
  body,
}: {
  caseTemplateId: string;
  queryType: string;
  dataSourceId?: string;
  name: string;
  body: string;
}) => {
  return async () => {
    return await SessionClientDashboard.postResourceCreate<
      CaseQuery,
      ApiSingletonPayload<{
        'query-type': string;
        'case-template-id': string;
        'external-integration-id'?: string;
        name: string;
        body: string;
      }>
    >({
      type: ApiModel.CaseQuery,
      attributes: {
        'query-type': queryType,
        'case-template-id': caseTemplateId,
        'external-integration-id': dataSourceId,
        name,
        body,
      },
    });
  };
};

export const updateCaseQuery = ({
  queryType,
  caseQueryId,
  caseTemplateId,
  formData,
}: {
  queryType: string;
  caseQueryId: string;
  caseTemplateId: string;
  formData: FormEditCaseQueryData;
}) => {
  return async () => {
    return await SessionClientDashboard.updateResource<
      CaseQuery,
      ApiPayload<
        {
          'query-type': string;
          'external-integration-id': string;
          'case-template-id': string;
          name: string;
          body: string;
        },
        ApiModel.CaseQuery
      >
    >({
      type: ApiModel.CaseQuery,
      id: caseQueryId,
      attributes: {
        'query-type': queryType,
        'case-template-id': caseTemplateId,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        'external-integration-id':
          queryType === 'javascript' ? null : formData.querySource.split('-')[1],
        name: formData.queryName,
        body: formData.queryBody,
      },
    });
  };
};
